module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01"
    }
  }, [_vm._v("Chapter 1. Political Brawls")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01#sec1.1"
    }
  }, [_vm._v("Fighting with Words")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01#sec1.2"
    }
  }, [_vm._v("Fighting with Fists")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01#sec1.3"
    }
  }, [_vm._v("Fighting (Fatally) with Firearms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2. Governors’ (Mis)Deeds")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#sec2.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joel Matteson and the Great Canal Scrip Scandal")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#sec2.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William H. Bissell’s Duel, Disingenuousness and Debilitating Disease")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3. Sex, Slander and Fighting")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#sec3.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lovers, Brothels and Venereal Diseases")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#sec3.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slanderous Statements and Atrocious Accusations")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#sec3.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fighting Dirty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4. Slavery in the Emancipator’s Hometown")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#sec4.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Springfield’s Slaves and Indentured Servants")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#sec4.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fugitive Slave Case")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5. Abraham Lincoln’s Scandal")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#sec5.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Poison Pen")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#sec5.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Duel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6. Murder Most Foul")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#sec6.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Trailor Mystery: The Murder that Wasn’t")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#sec6.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bumped Off in the Backyard")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#sec6.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Shot in the Dark")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#sec6.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Infanticide of an Illegitimate Child")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#sec6.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Dance Turns Deadly")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7. Civil War Shenanigans")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#sec7.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Revelry and Riots")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#sec7.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Officer with a Hair-Trigger Temper")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#sec7.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shot by a Soldier in the Street")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#sec7.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lincoln’s Wartime Nepotism Gone Bad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/bibli",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0